import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import LearnProcessProvider from "../../../Providers/Data/LearnProcessProvider.jsx";
import useCompanyTitle from "../../../hooks/useCompanyTitle.js";
import DeckContent from "./DeckContent.jsx";
import LevelHeader from "../Course/components/LevelHeader.jsx";
import { LEARN_PAGE_TOP_ANCHOR_ID } from "../../../Utils/misc.js";

const useStyles = makeStyles((theme) => ({
  backBtn: {
    marginTop: "16px",
    fontWeight: "bold",
  },
  learnRoot: {
    padding: "16px 22px",
  },
  infoCardsRight: {
    display: "flex",
    flexDirection: "column",
    margin: "32px 16px 0 16px",
    [theme.breakpoints.up("lg")]: {
      margin: "16px 40px 0 0",
    },
    position: "relative",
  },
  infoCardsLeft: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  trainingButton: {
    margin: "15px 0 0",
    [theme.breakpoints.up("lg")]: {
      margin: "15px 0 30px",
    },
  },
}));

/** */
const Learn = () => {
  const classes = useStyles();

  useCompanyTitle("title.learn");

  return (
    <Box id={LEARN_PAGE_TOP_ANCHOR_ID} className={classes.learnRoot}>
      <LevelHeader isLearnPage />
      <LearnProcessProvider>
        <DeckContent />
      </LearnProcessProvider>
    </Box>
  );
};

export default Learn;
